import i18next from 'i18next';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useLanguageUtm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('utm_content')) {
      url.searchParams.append('utm_content', i18next.language);
      navigate(`${url.pathname}${url.search}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18next.language]);
};
